import { Link } from "react-router-dom";

import facebookSvg from "src/assets/img/obzerwuj/facebook.svg";
import instagramSvg from "src/assets/img/obzerwuj/instagram.svg";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__main main-footer">
          <div className="main-footer__menu menu-footer main-footer__block">
            <h5 className="menu-footer__title">Menu</h5>
            <div className="menu-footer__items items-block">
            	<Link className="menu-footer__item">Strona główna</Link>
	            <Link className="menu-footer__item">Sale</Link>
	            <Link className="menu-footer__item">Wypożyczalnia</Link>
            </div>
          </div>
          <div className="main-footer__social social-footer main-footer__block">
            <h5 className="social-footer__title">Socials</h5>
            <div className="social-footer__items items-block">
              <a href="https://www.facebook.com/studio.labirynt">
                <img src={facebookSvg} alt="facebook"></img>
              </a>
              <a href="https://www.instagram.com/labirynt.studio/#">
                <img src={instagramSvg} alt="instagram"></img>
              </a>
            </div>
          </div>
          <div className="main-footer__contacts contacts-footer main-footer__block">
            <h5 className="contacts-footer__title">kontakt</h5>
            <div className="contacts-footer__items items-block">
              <a
                href="tell:+48600507402"
                className="contacts-footer__phone contacts-footer__item"
              >
                +48 600 507 402
              </a>
              <a
                href="mailto:wynajmij@labiryntstudio.pl"
                className="contacts-footer__item"
              >
                wynajmij@labiryntstudio.pl
              </a>
            </div>
          </div>
        </div>
        <div className="footer__bottom bottom-footer">
          <div className="bottom-footer__sp">Labirynt Studio Sp. z o.o.</div>
          <div className="bottom-footer__regulamin">
            <a  href="#">Regulamin</a> <a  href="#">Polityka prywatności</a> <a  href="#">RODO</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
